import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import PointWidget from "../dataProducts/PointWidget";
import ViewWidget from "../dataProducts/ViewWidget";
import ObsWidget from "./ObsWidget";
import {logScaleVariables, radScaleVariables, vectorColormaps, vectorVariables} from "../../../utils/globals";
import cloneDeep from "lodash/cloneDeep";


const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  obs_widget: {},
  slice_widget: {},
  point_widget: {},
  view_widget: {},
}

const DEFAULTS= {
  sim_widget: {
    domain: 'cor',
    variable: 'br',
    data_product: 'chmap',
    time_of_interest: null,
  },
  obs_widget: {
    sc_id: 'omni',
    taxis_min: null,
    taxis_max: null,
    query_time: false,
    time_tvalue: null,
    show_point_cloud: false,
    number_of_points: 16,
    cloud_sphere_radius: 1,
    show_text: true,
    sync_state: false,
    color: 'rainbow',
  },
  slice_widget: {
    slice: 'r',
    slice_param1: null,
    abs_transform: false,
    log_transform: false,
    rad_transform: true,
    rad_transform_exponent: 2,
    units: 'real',
    show_text: true,
    color: 'psi_blue_gray_red'
  },
  point_widget: {
    query_point: false,
    point_xvalue: null,
    point_yvalue: null,
    line_width: 0.8,
    line_style: 'dashed',
    marker_symbol: 'o',
    color: '#A2000B',
    show_point: true,
    show_lines: true,
    show_text: true,
  },
  view_widget: {
    xaxis_min: null,
    xaxis_max: null,
    xaxis_ticks: null,
    yaxis_min: null,
    yaxis_max: null,
    yaxis_ticks: null,
    zaxis_min: null,
    zaxis_max: null,
    zaxis_ticks: null,
    symmetric: true,
    symmetric_value: null,
    grid: null,
  },
}

const sharedData = {
  sim_widget: {data_product: null}
}

const flagTriggers = {
  sim_widget: {variable: true, data_product: true},
}

const flagDependencies = {
  sim_widget: {variable: null},
  slice_widget: {color: null, log_transform: null, rad_transform: null, rad_transform_exponent: null},
  view_widget: {symmetric: null}
}

const flagValidators = (widget, k, v, dependencies) => {
  const modifiedParams = cloneDeep(PARAM_SCHEMA);

  if ((k === 'data_product') && (v === 'chmap')) {
    modifiedParams.slice_widget.color = 'psi_blue_gray_red';
  } else {
    let variable = k === 'variable' ? v : dependencies.sim_widget.variable;
    const isVectorVariable = vectorVariables.includes(variable);
    const isVectorColormap= vectorColormaps.includes(dependencies.slice_widget.color);
    const isSymmetric = dependencies.view_widget.symmetric;
    const isRadScaleVariable = radScaleVariables.includes(variable);
    const isLogScaleVariable = logScaleVariables.includes(variable);

    if (isVectorVariable !== isVectorColormap) {
      modifiedParams.slice_widget.color = isVectorVariable
        ? "psi_blue_red"
        : "rainbow";
    }

    if (isVectorVariable !== isSymmetric) {
      modifiedParams.view_widget.symmetric = isVectorVariable;
      modifiedParams.view_widget.symmetric_value = null;
      modifiedParams.view_widget.zaxis_min = null;
      modifiedParams.view_widget.zaxis_max = null;
    }

    if (isLogScaleVariable !== dependencies.slice_widget.log_transform) {
      modifiedParams.slice_widget.log_transform = isLogScaleVariable;
    }

    if (isRadScaleVariable !== dependencies.slice_widget.rad_transform) {
      modifiedParams.slice_widget.rad_transform = isRadScaleVariable;
      modifiedParams.slice_widget.rad_transform_exponent = 2;
    }
  }

  modifiedParams[widget][k] = v;
  return { widget_: "_", params_: modifiedParams };
};

const SpacecraftMapping = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='spacecraft_mapping'
        toolName='SPACECRAFT MAPPING'
        sharedDeps={sharedData}
        flagTriggers={flagTriggers}
        flagDeps={flagDependencies}
        flagValidators={flagValidators}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        pointWidget={PointWidget}
        viewWidget={ViewWidget}
        obsWidget={ObsWidget}
      />
    </>

  )
}

export default SpacecraftMapping;